import {
    /** FETCH APPLICATION  */
    FETCH_PAGINGAPPLICATION_FULFILLED,
    FETCH_PAGINGAPPLICATION_REJECTED,
    FETCH_PAGINGAPPLICATION_PENDING,
    RESET_PAGINGAPPLICATION
} from "../../actions/v3/pagingApplications";
const initialState = {
    done: false,
    error: false,
    spinner: false
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_PAGINGAPPLICATION_PENDING:
            return {
                done: false,
                error: false,
                spinner: true
            };
        case FETCH_PAGINGAPPLICATION_FULFILLED:
            return {
                ...state,
                pagingApplications: action.payload,
                done: true,
                spinner: false
            };
        case FETCH_PAGINGAPPLICATION_REJECTED:
            return {
                ...state,
                error: action.payload,
                done: false,
                spinner: false
            };
        case RESET_PAGINGAPPLICATION:
            return {
                initialState,
                done: false,
                error: false,
            };
        default:
            return state;
    }
};